import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import type { ViewEntityType } from "@colab/shared";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// DELETE /api/admin/views/:id
//
// Pessimistic: a soft-optimistic remove would briefly hide a row the
// server might reject (system view, missing settings.write, etc.). The
// dialog cost gives the user time to reconsider; the network round-trip
// is short.

type Vars = { id: string; entityType: ViewEntityType };

export function useDeleteView() {
  const queryClient = useQueryClient();
  return useMutation<void, ApiClientError, Vars>({
    mutationFn: async ({ id }) => {
      await apiFetch<void>(`/admin/views/${id}`, { method: "DELETE" });
    },
    onSuccess: (_data, { entityType }) => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.views.list(entityType),
      });
      toast.success("View deleted");
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to delete view");
    },
  });
}
